import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { vitecompanyserviceurl } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";
import { attachRefreshInterceptor } from "src/utils/axiosRefreshInterceptor";
import { api } from "src/constants/global-const";

const orderInstance: AxiosInstance = axios.create({
    baseURL: api + '/api/v1',
});

const companyserviceurl: AxiosInstance = axios.create({
    baseURL: vitecompanyserviceurl + "/api/v1/oms",
});

const basecompanyserviceurl: AxiosInstance = axios.create({
    baseURL: vitecompanyserviceurl,
});

const companyserviceurlevent: AxiosInstance = axios.create({
    baseURL: vitecompanyserviceurl,
});

orderInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
companyserviceurl.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
basecompanyserviceurl.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
companyserviceurlevent.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));

// Attach 403 refresh-and-retry interceptors
attachRefreshInterceptor(orderInstance);
attachRefreshInterceptor(companyserviceurl);
attachRefreshInterceptor(basecompanyserviceurl);
attachRefreshInterceptor(companyserviceurlevent);

export const getProductDetails = (payload: any) => {
    return orderInstance.get(`/product/details`, {
        params: {
            company_id: payload?.company_id,
            company_divisioncode_visible: true,
            selectcompany_getactivedivisons: true,
            company_divisioncode: payload?.division_codes,
            perPage: 10,
            page: 1,
            globalSearch: payload?.search,
        },
    });
};


export const getStockistDetails = (payload: any) => {
    return orderInstance.get(`/stockist/details`, {
        params: {
            company_code: payload?.company_code,
            perPage: 0,
            page: 0,
            search: payload?.search,
            report: true //M10-13112
            // state_id: payload?.state_codes,
        },
    });
};

export const getCounterDetails = (payload: any) => {
    return orderInstance.get(`/counter/v2/search`, {
        params: {
            company_id: payload?.company_id,
            counter_code: payload?.counter_code,
            ...(payload?.division_code && {
                division_id: payload.division_code,
            }),
            perPage: 10,
            page: 0,
            speciality: true,
            location: true,
        },
    });
};

export const getProductsReport = (payload: any) => {
    return orderInstance.get(`/report`, {
      params: {
        page: payload?.page,
        limit: payload?.limit,
        report_type: payload?.report_type,
      },
    });
  };

export const generateCounterProductReport = (payload: any) => {
    return orderInstance.post(`/report`, payload);
  };

export const getOperationalMetricsOms = (companyCode?: string) => {
    return companyserviceurl.get(`/operational-metrics`, {
        headers: { company_code: companyCode || 0 },
    });
};

export const getOperationalMetricsCorp = () => {
    return orderInstance.get(`/operational-metrics`);
};